module.exports = __webpack_public_path__ + "img/IMG_9920.d098f4e2.jpg";